export default __webpack_public_path__ + "static/media/hazhozszallitas_Wolt.76d96f24.png";